import { setViewportBottomInset } from '../../utils/viewportBottomInset';

let attached = false;

/**
 * Mirror MathLive's virtual-keyboard height into the global `--viewport-bottom-inset` CSS var, so
 * containers (the shared Modal) shrink above the keyboard in pure CSS instead of
 * re-rendering on its geometry events (bug 535585). One app-wide subscription, attached when the
 * first author field initializes; never detached — the keyboard is a singleton and the inset simply
 * rests at 0 while it is hidden.
 */
export function ensureVirtualKeyboardInsetMirror(): void {
  const keyboard = window.mathVirtualKeyboard;
  if (attached || !keyboard) return;
  attached = true;

  const update = () => {
    setViewportBottomInset(keyboard.visible ? keyboard.boundingRect.height : 0);
  };
  keyboard.addEventListener('virtual-keyboard-toggle', update);
  keyboard.addEventListener('geometrychange', update);
  update();
}
